function Qatar({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1945)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M32 16C32 7.1635 24.8365 0 16 0C12.87 0 9.95036 0.899687 7.48424 2.45319L10.9913 3.94325L6.26086 5.95312L10.9913 7.96294L6.26086 9.97269L10.9913 11.9824L6.26086 13.9918L10.9913 16.0011L6.26086 18.0109L10.9913 20.0205L6.26086 22.0299L10.9913 24.0396L6.26086 26.0493L10.9913 28.0588L7.4858 29.548C9.95161 31.1007 12.8706 32 16 32C24.8365 32 32 24.8365 32 16Z" fill="#751A46"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Qatar;
